import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Emoji } from "projects/pax-ui/components/emoji/emoji-alt-mapping";
import { map } from "rxjs";
import { FormName } from "src/app/shared/models/form-name";
import { DocumentType } from "src/app/shared/store/quote/product-configuration.factory";
import { BasePage, PremiumFormModel } from "../base/base.page";
import { CheckoutPage } from "../checkout-page/checkout-page";

@UntilDestroy()
@Component({
  selector: "app-optional-email",
  imports: [CommonModule, CheckoutPage],
  templateUrl: "../base/base.page.html",
  styleUrls: ["../base/base.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionalEmailPage extends BasePage implements OnInit {
  public override enableBackButton = false;
  public override enableSkipButton = true;
  public override emojis: Emoji[] = ["👋"];

  termsDataProcessingPdfUrl = this.quoteFacade.createDownloadDocumentUrl(
    this.productSpecificCustomRouteData.product,
    DocumentType.INFO_DATA_PROCESSING,
  );

  termsEmailCommunicationPdfUrl = this.quoteFacade.createDownloadDocumentUrl(
    this.productSpecificCustomRouteData.product,
    DocumentType.AGREEMENT_EMAIL_COMMUNICATION,
  );

  termsElectronicDirectSalesUrl = this.quoteFacade.createDownloadDocumentUrl(
    this.productSpecificCustomRouteData.product,
    DocumentType.INFO_ELECTRONIC_DIRECT_SALES,
  );

  public override formConfiguration = {
    name: FormName.CONTACT_DETAILS,
    rows: [
      // Row 1
      {
        items: [this.formComponentService.getEmailAddressField()],
      },
      // Row 2
      {
        items: [
          this.formComponentService.getAcceptedTermsField(
            this.termsDataProcessingPdfUrl,
            this.termsEmailCommunicationPdfUrl,
            this.termsElectronicDirectSalesUrl,
          ),
        ],
      },
    ],
  };

  ngOnInit() {
    super.initialize(this.formConfiguration);
    this.data$ = this.loadFormValuesFromStoreObservable();
  }

  private loadFormValuesFromStoreObservable() {
    return this.quoteStoreFacade
      .getOptionalPageState(this.productSpecificCustomRouteData.product)
      .pipe(
        untilDestroyed(this),
        map((optionalEmailPageState) => {
          const premiumForm: PremiumFormModel = {
            email: optionalEmailPageState.email,
            mobilePhoneNumber: optionalEmailPageState.mobilePhoneNumber,
            acceptedTerms: {
              yes: optionalEmailPageState.hasTermsAccepted,
            },
          };
          return premiumForm;
        }),
      );
  }
}
